import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FiGlobe, FiSmartphone } from 'react-icons/fi';
import { FormGroup } from 'reactstrap';
import {
  fetchActiveInactiveUserListByDate,
  fetchLoginReportMonthWise,
  getStateHeadTMById,
} from '../../constants/apiCalls';
import ModalService from '../../services/ModalService';
import Storage from '../../services/Storage';
import { handleErrorMessage } from '../../utils/utils';
import { SingleSelect } from '../CommonComponents';

import tableExcel from '../../images/tableExcel.png';

import './LoginUserList.css';

const UserListItem = ({ onClick, user }) => {
  return (
    <div className="userListItem">
      <div className="userItemFlex">
        <div>
          <p className="userListItemTitle" onClick={() => onClick(user)}>
            <span className="userListItemName">{user.user_name}</span>
            <span className="userItemPosition">({user.role})</span>
          </p>
          <p className="userListStates">
            (
            {user &&
              user.territory_or_state &&
              user.territory_or_state.join(', ')}
            )
          </p>
        </div>
        <div className="userListItemDevices">
          {user.device_type && user.device_type.includes('web') && (
            <FiGlobe size="22px" color="blue" />
          )}
          {user.device_type && user.device_type.includes('mobile') && (
            <FiSmartphone size="22px" color="blue" />
          )}
        </div>
      </div>
      <div className="listDivider"></div>
    </div>
  );
};

const LoginUserList = ({
  viewUser,
  currentDate,
  setLoading,
  selectedTab,
  setSelectedTab,
}) => {
  const [stateId, setStateId] = useState('');
  const [activeUserList, setActiveUserList] = useState([]);
  const [inactiveUserList, setInactiveUserList] = useState([]);

  const [stateList, setStateList] = useState([]);

  const selectedStateId =
    stateList.filter((val) => val.name === stateId)[0] &&
    stateList.filter((val) => val.name === stateId)[0].state_id;

  // Get current user id
  let userInfo = Storage.getUserInfoDetail();
  let loginId = userInfo ? userInfo.id : null;

  useEffect(() => {
    getStateHeadTMById(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setStateList(data[0].state || []);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      { id: loginId },
    );
  }, []);

  useEffect(() => {
    const payload = { date: moment(currentDate).format('YYYY-MM-DD') };
    setLoading(true);
    if (selectedStateId) {
      payload.state_id = selectedStateId;
    }

    fetchActiveInactiveUserListByDate((res) => {
      const { data, success, error } = res;

      if (success) {
        setLoading(false);
        setActiveUserList(data[0].activeusers || []);
        setInactiveUserList(data[0].inactiveusers || []);
      } else if (success === false || success === 'undefined') {
        setLoading(false);

        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
    }, payload);
  }, [currentDate, selectedStateId]);

  const handleClickExcel = () => {
    setLoading(true);
    const payload = {
      month: moment(currentDate).month() + 1,
      year: moment(currentDate).year(),
    };
    if (selectedStateId) {
      payload.state_id = selectedStateId;
    }

    fetchLoginReportMonthWise((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setLoading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setLoading(false);
      }
      setLoading(false);
    }, payload);
  };

  return (
    <div className="loginUserList">
      <div className="tabs">
        <button
          onClick={() => setSelectedTab(0)}
          className={selectedTab === 0 ? 'active' : ''}
        >
          <span className="greenDot"></span> Active Users
        </button>
        <button
          onClick={() => setSelectedTab(1)}
          className={selectedTab === 1 ? 'active' : ''}
          style={{ borderLeft: '1px solid #cecece' }}
        >
          <span className="redDot"></span> In-Active Users
        </button>
      </div>
      <div className="userListStateSelect">
        <div>
          <p>Select State</p>
          <FormGroup>
            <SingleSelect
              id="state"
              name="state"
              value={stateId === null || stateId === 'undefined' ? '' : stateId}
              onChange={(e) => {
                setStateId(e.target.value);
              }}
              options={stateList}
              label={'name'}
              selectedValueKey={'id'}
            />
          </FormGroup>
        </div>
        <img
          src={tableExcel}
          style={{ cursor: 'pointer' }}
          className="excelImg"
          alt="Excel Export"
          onClick={handleClickExcel}
        />
      </div>
      <div className="userListContainer">
        {selectedTab === 0 &&
          activeUserList.map((data) => (
            <UserListItem onClick={viewUser} user={data} />
          ))}
        {selectedTab === 1 &&
          inactiveUserList.map((data) => (
            <UserListItem onClick={viewUser} user={data} />
          ))}
        {inactiveUserList.length === 0 && activeUserList.length === 0 && (
          <p className="noDataFound">No Data Found</p>
        )}
      </div>
    </div>
  );
};

export default LoginUserList;
